<!--<div class="row m-0">-->
<!--  <div class="col-sm-5 p-0"-->
<!--    style="width: 50%;float: left;height: 100vh;-->
<!--      background-repeat: no-repeat;-->
<!--    background-size: cover;-->
<!--    background-image: url(assets/images/bg-demo.jpg);">-->
<!--  </div>-->
<!--  <div class="col-sm-7 p-0 text-left">-->
<!--    <div class="contact-form">-->
<!--      <h4>SignIn</h4>-->
<!--&lt;!&ndash;      <p>Enter your username and password</p>&ndash;&gt;-->
<!--      <div class="">-->
<!--        <input class="" placeholder="Username">-->
<!--        <input class="" placeholder="Password" type="password" name="name">-->
<!--        <button type="submit" class="btn btn-primary font-weight-bold py-2 mt-2" style="width: 150px" (click)="submit()">Submit</button>-->
<!--        <div>-->
<!--          <a routerLink="/" style="font-size: 12px">Back to home page</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->



<div class="row m-0">
  <div class="col-12 p-0"
       style="width: 50%;float: left;height: 100vh;
      background-repeat: no-repeat;
    background-size: cover;
    background-image: url(assets/images/bg-demo.jpg);">
    <div class="contact-form">
      <h4>SignIn</h4>
      <!--      <p>Enter your username and password</p>-->
      <div class="">
        <input class="" placeholder="Username">
        <input class="" placeholder="Password" type="password" name="name">
        <button type="submit" class="btn btn-primary font-weight-bold py-2 mt-2" style="width: 150px" (click)="submit()">Submit</button>
        <div>
          <a routerLink="/" style="font-size: 12px">Back to home page</a>
        </div>
      </div>
    </div>
  </div>
</div>
